import { Backdrop as MuiBackdrop } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';

export const Backdrop = withStyles({
  root: {
    background: 'rgba(255, 255, 255, 0.9)',
  },
})(MuiBackdrop);
